import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'canViewFileInBrowser' })
export class CanViewFileInBrowserPipe implements PipeTransform {
    /**
     * File extensions that are viewable in the browser
     */
    private readonly viewableExtensions = ['.pdf', '.jpg', '.png', '.txt', '.md', '.html'];

    /**
     * Determine if a filename can be viewed in the browser by looking at its file extension
     * @param fileName name of the file to check
     * @returns true if it is viewable in the browser, false if it is not
     */
    transform(fileName: string | undefined): boolean {
        if (!fileName) {
            return false;
        }
        const lowerName = fileName.toLowerCase();
        return this.viewableExtensions.some((extension) => lowerName.endsWith(extension));
    }
}
